import type { ReactNode } from "react";
import { cn } from "@core/utils";

interface AuthCardProps {
  children: ReactNode;
  className?: string;
}

/**
 * The card on the signed-out frame (Figma): white, 1px border, 16px radius, 40px padding, 24px
 * rhythm between its parts, 440px wide. Everything on the setup, invitation and reset screens sits
 * in one of these; `AuthLayout` supplies the page, the logo and the language pill around it.
 * Padding eases to 24px on a small screen so the card keeps its content width at 320px.
 */
export function AuthCard({ children, className }: AuthCardProps) {
  return (
    <div
      className={cn(
        "flex w-full max-w-110 flex-col gap-xl rounded-xl border border-(--border-default) bg-surface-card p-xl sm:p-3xl",
        className
      )}
    >
      {children}
    </div>
  );
}
